import React, { useEffect, useMemo, useState } from "react";
import { /* describeFaltas, */ formatDateTime } from "./rootDashboardUtils";

export default function RootAssignmentsSection({
  activeSessions = [],
  activeSessionsCount = 0,
  /* usersMissingAssignments = [], */
  onExpireSession,
  onSetTemporaryPassword,
}) {
  const [expiringId, setExpiringId] = useState(null);
  const [passwordId, setPasswordId] = useState(null);
  const [modal, setModal] = useState(null);
  const [tempPassword, setTempPassword] = useState("");
  const [tempPasswordError, setTempPasswordError] = useState("");

  const modalSession = modal?.session || null;
  const modalLabel = useMemo(
    () => modalSession?.usuario || modalSession?.email || "este usuario",
    [modalSession]
  );
  const isExpireModal = modal?.type === "expire";
  const isModalOpen = Boolean(modal);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (isModalOpen) document.body.classList.add("modal-open");
    else document.body.classList.remove("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [isModalOpen]);

  const closeModal = () => {
    setModal(null);
    setTempPassword("");
    setTempPasswordError("");
  };

  const openExpireModal = (session) => {
    if (!onExpireSession) return;
    setModal({ type: "expire", session });
  };

  const confirmExpire = async () => {
    if (!onExpireSession || !modalSession) return;
    setExpiringId(modalSession.id);
    try {
      await onExpireSession(modalSession.id);
      closeModal();
    } catch (error) {
      console.error("Error caducando sesion", error);
    } finally {
      setExpiringId(null);
    }
  };

  const openPasswordModal = (session) => {
    if (!onSetTemporaryPassword) return;
    setTempPassword("");
    setTempPasswordError("");
    setModal({ type: "password", session });
  };

  const confirmTempPassword = async () => {
    if (!onSetTemporaryPassword || !modalSession) return;
    const nextPassword = tempPassword.trim();
    if (nextPassword.length < 6) {
      setTempPasswordError("La contrasena temporal debe tener al menos 6 caracteres.");
      return;
    }
    setPasswordId(modalSession.id);
    try {
      await onSetTemporaryPassword(modalSession.id, nextPassword);
      closeModal();
    } catch (error) {
      console.error("Error aplicando contrasena temporal", error);
    } finally {
      setPasswordId(null);
    }
  };

  return (
    <div className="row g-3 mb-4" id="root-sessions-recent">
      <div className="col-12">
        <div className="management-card root-section-card h-100">
          <div className="root-card-header">
            <div>
              <h6 className="root-card-title mb-1">Sesiones recientes</h6>
              <small className="text-muted">Activas y ultima caducada por usuario</small>
            </div>
            <span className="management-pill root-chip">
              <i className="bi bi-circle-fill" />
              {activeSessionsCount}
            </span>
          </div>
          <div className="management-table-wrapper">
            <table className="table management-table mb-0">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>Email</th>
                  <th>Estado</th>
                  <th>IP</th>
                  <th>Inicio</th>
                  <th>Expira</th>
                  <th className="text-end">Accion</th>
                </tr>
              </thead>
              <tbody>
                {activeSessions.length ? (
                  activeSessions.map((row) => (
                    <tr key={row.id}>
                      <td>
                        <span className="root-session-user">
                          <span
                            className={`root-session-dot ${row.activa ? "" : "is-inactive"}`}
                            title={row.activa ? "Activa" : "Caducada"}
                            aria-hidden="true"
                          />
                          {row.usuario || row.email}
                        </span>
                      </td>
                      <td>{row.email || "-"}</td>
                      <td>{row.activa ? "Activa" : "Caducada"}</td>
                      <td>{row.ip || "-"}</td>
                      <td>{formatDateTime(row.creado)}</td>
                      <td>{row.expira ? formatDateTime(row.expira) : "Sin expiracion"}</td>
                      <td className="text-end">
                        <div className="root-session-actions">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => openPasswordModal(row)}
                            disabled={!onSetTemporaryPassword || passwordId === row.id}
                            title="Asignar contraseña temporal"
                          >
                            <i className="bi bi-pencil" />
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger root-session-action"
                            onClick={() => openExpireModal(row)}
                            disabled={
                              !onExpireSession || expiringId === row.id || row.activa === false
                            }
                          >
                            {expiringId === row.id ? "Caducando..." : "Caducar"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center text-muted py-3">
                      Sin sesiones registradas
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/*
      <div className="col-12 col-xl-6">
        <div className="management-card root-section-card h-100">
          <div className="root-card-header">
            <div>
              <h6 className="root-card-title mb-1">Usuarios sin rol o centro</h6>
              <small className="text-muted">Asignaciones pendientes</small>
            </div>
            <span className="management-pill root-chip">
              <i className="bi bi-person-lock" />
              {usersMissingAssignments.length}
            </span>
          </div>
          <div className="management-table-wrapper">
            <table className="table management-table mb-0">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>Email</th>
                  <th>Estado</th>
                  <th>Falta</th>
                </tr>
              </thead>
              <tbody>
                {usersMissingAssignments.length ? (
                  usersMissingAssignments.map((row) => (
                    <tr key={row.id}>
                      <td>{row.nombre}</td>
                      <td>{row.email}</td>
                      <td>{row.estado}</td>
                      <td>{describeFaltas(row)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center text-muted py-3">
                      Sin usuarios pendientes
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      */}

      {isModalOpen && (
        <>
          <div className="modal fade show d-block management-modal" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <div>
                    <p className={`dashboard-eyebrow mb-1 ${isExpireModal ? "text-danger" : ""}`}>
                      {isExpireModal ? "Seguridad" : "Contrasena temporal"}
                    </p>
                    <h5 className="modal-title mb-0 d-flex align-items-center gap-2">
                      <i className={`bi ${isExpireModal ? "bi-shield-x" : "bi-pencil-square"}`} />
                      {isExpireModal ? "Caducar sesion" : "Cambiar contrasena"}
                    </h5>
                  </div>
                  <button type="button" className="btn-close" onClick={closeModal} />
                </div>
                <div className="modal-body">
                  {isExpireModal ? (
                    <>
                      <p className="mb-2">
                        Vas a caducar la sesion de <strong>{modalLabel}</strong>.
                      </p>
                      <p className="text-muted mb-0">
                        El usuario saldra del sistema en su siguiente accion.
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="mb-2">
                        Define una contrasena temporal para <strong>{modalLabel}</strong>.
                      </p>
                      <p className="text-muted mb-3">
                        Esto cerrara todas sus sesiones activas y debera contactar soporte.
                      </p>
                      <label className="form-label dashboard-label">Contrasena temporal</label>
                      <input
                        type="text"
                        className={`form-control ${tempPasswordError ? "is-invalid" : ""}`}
                        value={tempPassword}
                        onChange={(event) => {
                          setTempPassword(event.target.value);
                          if (tempPasswordError) setTempPasswordError("");
                        }}
                        placeholder="Minimo 6 caracteres"
                        autoFocus
                      />
                      {tempPasswordError && (
                        <div className="invalid-feedback d-block">{tempPasswordError}</div>
                      )}
                    </>
                  )}
                </div>
                <div className="modal-footer border-0 pt-0">
                  <button type="button" className="btn btn-outline-secondary" onClick={closeModal}>
                    Cancelar
                  </button>
                  {isExpireModal ? (
                    <button
                      type="button"
                      className="btn btn-danger text-white"
                      onClick={confirmExpire}
                      disabled={expiringId === modalSession?.id}
                    >
                      {expiringId === modalSession?.id ? "Caducando..." : "Caducar"}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary text-white"
                      onClick={confirmTempPassword}
                      disabled={passwordId === modalSession?.id}
                    >
                      {passwordId === modalSession?.id ? "Aplicando..." : "Aplicar"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" onClick={closeModal} />
        </>
      )}
    </div>
  );
}
